import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button } from "antd";

const columns = (naviagteTo, showModal) => [
  {
    title: " Code",
    dataIndex: "code",
    key: "code",
  },
  {
    title: " Nom",
    dataIndex: "firstname",
    key: "name",
  },
  {
    title: " Prénom",
    dataIndex: "lastname",
    key: "lastname",
  },
   {
    title: "Personnes Assignées",
    dataIndex: "delegates",
    key: "delegates",
    render: (delegates) => (
      <div style={{ fontSize: '12px', color: '#555' }}>
        {delegates && delegates.length > 0 
          ? delegates.map(d => `${d.firstname} ${d.lastname}`).join(', ') 
          : "Aucun délégué"}
      </div>
    ),
  },
  {
    title: "Pharmacie",
    dataIndex: "pharmacien",
    key: "pharmacy",
    render: (data) => <>{data?.pharmacyName}</>,
  },
  {
    title: "Type",
    dataIndex: "pharmacien",
    key: "pharmacyType",
    render: (data) => <>{data?.pharmacyType === 1 ? "Jour" : "Nuit"}</>,
  },
  // {
  //   title: "Personne à contacter",
  //   dataIndex: "pharmacien",
  //   key: "contact",
  //   render: (data) => <>{data?.contact}</>,
  // },
  {
    title: "Gouvernorat",
    dataIndex: "government",
    key: "gouvernorat",
    render: (data) => <>{data?.name}</>,
  },
  {
    title: "Région",
    dataIndex: "region",
    key: "region",
    render: (data) => <>{data?.name}</>,
  },
  {
    title: "Address",
    dataIndex: "address",
    key: "address",
  },
  {
    title: "Téléphone",
    dataIndex: "phoneNumber",
    key: "phone",
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Action",
    key: "action",
    render: (record) => (
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        
        {/* BOUTON MODIFIER (Bleu foncé arrondi) */}
        <Button
          className="btn-details" // Utilise la classe CSS globale
          onClick={() => naviagteTo(`edit/pharmacie/${record.id}`)}
          icon={<EditOutlined />} // Icône intégrée
        >
          Modifier
        </Button>

        {/* BOUTON SUPPRIMER (Icône Rouge) */}
        <Button 
            type="text" 
            danger 
            onClick={() => showModal(record.id)}
            icon={<DeleteOutlined style={{ fontSize: '18px' }} />}
        />
      </div>
    ),
  },
];

export default columns;